"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDownloadUrl = void 0;
const api_1 = require("@streem/api");
const logger_1 = require("./logger");
function fetchDownloadUrl(roomId, storageUrl, maxRetries = 3) {
    return __awaiter(this, void 0, void 0, function* () {
        for (let i = 0; i < maxRetries; i++) {
            try {
                const { downloadUrl } = yield api_1.StreemAPI.downloads.createSignedDownloadUrl({
                    storageUrl,
                    scope: api_1.StreemApiCreateSignedDownloadUrlRequestScope.ROOM,
                    scopeSid: roomId.toString(),
                });
                if (downloadUrl)
                    return downloadUrl;
            }
            catch (e) {
                // Thrown error usually suggests retries won't be successful
                logger_1.logger.error('Failed to create signed downloadUrl for storageUrl', storageUrl, e);
                return undefined;
            }
            // Sometimes, storage URL is available before item actually exists. Wait 5s between tries for upload to complete.
            yield new Promise(res => setTimeout(res, 5000));
        }
        logger_1.logger.error('Failed to create signed downloadUrl for storageUrl', storageUrl, 'Ran out of retries');
    });
}
exports.fetchDownloadUrl = fetchDownloadUrl;
//# sourceMappingURL=fetch_download_url.js.map